<template>
  <select class="switcher-lang" @change="changeLocale" v-model="selectedLanguage">
    <option class="test" value="en">en</option>
    <!--<option value="pl">pl</option>-->
    <option value="uk">ua</option>
  </select>
</template>

<script>
export default {
  data () {
    return {
      selectedLanguage: localStorage.getItem('selectedLanguage') || 'en'
    }
  },
  methods: {
    changeLocale () {
      this.$i18n.locale = this.selectedLanguage
      localStorage.setItem('selectedLanguage', this.selectedLanguage)
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/sass/app.scss";
  .switcher-lang{
    display: flex;
    padding: 4px 8px;
    align-items: center;
    justify-content: center;
    font-family: $main-font;
    gap: 4px;
    border-radius: 8px;
    background: #7A7CE81A;
    border: none;
    color: #30394B;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    text-transform: uppercase;
    cursor: pointer;
    &:hover{
      border-color: #888;
    }
    &:focus{
      outline: none;
    }
    option {
      background-color: #eeeeee;
      color: #333;
      padding: 4px 8px;
      border: none;
      cursor: pointer;
      &:checked {
        background-color: transparent;
        color: #30394B;
      }
    }
  }
  .switcher-lang::-ms-expand,
  .switcher-lang::-webkit-inner-spin-button,
  .switcher-lang::-webkit-outer-spin-button {
    display: none;
  }
</style>
